import { useState } from "react";
import { manualInputBtn } from "../../../consts/demandplanning";


export const MetaFieldForecastDemand = ({ 
    label, 
    value, 
    onChange, 
    wide 
}) => {

    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState(value);

    return (
        <div className={wide ? "col-span-2" : ""}>
            <p className="text-[10px] text-gray-500 uppercase tracking-wide font-medium mb-1">
                {label}
            </p>
            {editing ? (
                <input
                    autoFocus
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onBlur={() => {
                        onChange(draft);
                        setEditing(false);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onChange(draft);
                            setEditing(false);
                        }
                        if (e.key === "Escape") setEditing(false);
                    }}
                    className="w-full px-2 py-1 text-[12px] border border-gray-300 rounded-[4px] bg-white text-gray-900 outline-none"
                />
            ) : (
                <button
                    type="button"
                    onClick={() => {
                        setDraft(value);
                        setEditing(true);
                    }}
                    className={`${manualInputBtn} w-full text-left px-2 py-1 h-[31px]`}
                >
                    <span className="text-[12px] text-gray-900">{value || "—"}</span>
                </button>
            )}
        </div>
    );
}
